import {targets, useReferentialContext} from "../../Context";
import WindowContainer from "../../components/layout/WindowContainer";
import {TeamSelect} from "../../components/selectors/TeamSelect";
import {useEffect, useState} from "react";
import {Divider, Stack, Typography} from "@mui/material";
import {NeonTab, NeonTabs} from "../../NeonComponents/NeonTabs";
import {CompetitiveGames} from "../../reckon-api";
import dayjs, {Dayjs} from "dayjs";
import FilterSet from "../../components/selectors/Filterset";
import {NeonCard, NeonCardContent, NeonCardHeader} from "../../NeonComponents/NeonCards";
import {CenteredStack} from "../../NeonComponents/Stacks";
import {StatInStack} from "../../NeonComponents/Texts";
import formatters from "../../NeonComponents/Formatters";
import {Skeleton} from "@mui/lab";
import {NeonToggleButton} from "../../NeonComponents/NeonToggle";
import {ShieldIcon} from "../../components/Icons/AbilityIcon";
import {Block} from "@mui/icons-material";


export default function RoundStats(props: {target: targets}){
    const ctx = useReferentialContext()
    const [team, setTeam] = useState(ctx.selectedTeam);
    const [games, setGames] = useState<CompetitiveGames[]>([]);
    const [from, setFrom] = useState(dayjs().subtract(3,'month'));
    const [until, setUntil] = useState(dayjs());
    const [paramObject, setParamObject] = useState<any>({});
    const [mapsPlayed, setMapsPlayed] = useState([] as string[]);
    const [tab, setTab] = useState(0);
    const [sideTab, setSideTab] = useState(0);

    useEffect(() => {
        if(paramObject.watermark){
            ctx.reckonApi.competitiveGames.list(
                paramObject
            ).then(r => {
                setGames(r);
                setMapsPlayed([...new Set(r.map(g => g.map))])
            })
        }
    }, [paramObject.watermark]);

    return <WindowContainer direction={'column'} spacing={2}>
        <FilterSet paramObject={paramObject} setParamObject={setParamObject} target={props.target} team={team} setTeam={setTeam}
        date__gte={from} setDateGte={setFrom} date__lt={until} setDateLt={setUntil}/>
        <NeonTabs value={tab} onChange={(e, nv) => setTab(nv)}>
            <NeonTab label={'All'}/>
            {
                mapsPlayed.map(m => <NeonTab label={m}/>)
            }
        </NeonTabs>
        <Stack direction={'row'} spacing={1}>
            <RoundStatsTypeCard paramObject={{team1: team?.id ,additional_filters:{ round_index__in:'1,13', game_id__in: games.filter(g => tab === 0 ? true : g.map === mapsPlayed[tab-1]).map(g => g.id).toString()}}} title={'Pistol'}/>
            <RoundStatsTypeCard paramObject={{team1: team?.id , additional_filters:{ side:'Attacker', game_id__in: games.filter(g => tab === 0 ? true : g.map === mapsPlayed[tab-1]).map(g => g.id).toString()}}} title={'T Side'}/>
            <RoundStatsTypeCard paramObject={{team1: team?.id , additional_filters:{ side:'Defender', game_id__in: games.filter(g => tab === 0 ? true : g.map === mapsPlayed[tab-1]).map(g => g.id).toString()}}} title={'CT Side'}/>
        </Stack>
        <NeonTabs value={sideTab} onChange={(e, nv) => setSideTab(nv)}>
            <NeonTab label={'T/CT'}></NeonTab>
            <NeonTab label={'T'}></NeonTab>
            <NeonTab label={'CT'}></NeonTab>
        </NeonTabs>
        <LoadoutsStats paramObject={{team1: team?.id, additional_filters:{ side__in: sideTab === 0 ? 'Attacker,Defender' : (sideTab === 1 ? 'Attacker' : 'Defender'), game_id__in: games.filter(g => tab === 0 ? true : g.map === mapsPlayed[tab-1]).map(g => g.id).toString()} }}/>
    </WindowContainer>
}

function RoundStatsTypeCard(props: {paramObject: any, title: string}){
    const ctx = useReferentialContext();
    const [stats, setStats] = useState<any>(undefined as any);

    useEffect(() => {
        ctx.reckonApi.competitiveTeamRoundSummaries.aggregate(
            {...props.paramObject, aggregates: ['team_round_id__cnt,win__avg,kills__sum,deaths__sum'], groupby: 'team1', ordering: ['team1']}
        ).then(r => setStats(r[0]))
    }, [props.paramObject]);

    return <NeonCard>
        <NeonCardHeader title={props.title} sx={{mb:0}}/>
        <NeonCardContent >
            {stats ? <CenteredStack direction={'column'} sx={{width: '100%'}}>
                <StatInStack value={stats.team_round_id__cnt} label={'Rounds'} format={formatters.integer}/>
                <StatInStack value={stats.win__avg} label={'RWIN%'} format={formatters.percent}/>
                <StatInStack value={stats.kills__sum / stats.deaths__sum} label={'K/D'} format={formatters.float2}/>
            </CenteredStack> : <Skeleton sx={{width:'100%', height:'100%'}}/>}
        </NeonCardContent>
    </NeonCard>
}

function LoadoutsStats(props: {paramObject: any}){
    const [data, setData] = useState(null as any);
    const [players, setPlayers] = useState([] as string[])
    const ctx = useReferentialContext();
    useEffect(() => {
        ctx.reckonApi.competitiveRoundSummaries.aggregate(
            {...props.paramObject, ordering: ['player,shield'], groupby: 'player,shield', index_on: 'player', aggregates: ['round_id__cnt,win__avg,kills__sum,deaths__sum,assists__sum']}
        ).then(r => {
            setData(r);
            console.log(Object.entries(r));
            // @ts-ignore
            setPlayers(Object.entries(r).map((entry) => entry[0]))
        });
    }, [props.paramObject]);

    console.log(players);
    console.log(data);
    return <Stack direction={'row'}>
        {
            players.map(p => <ShieldStatsCard stats={data[p]} title={p}/>)
        }
    </Stack>
}

function ShieldStatsCard(props: {stats: any[], title: string}){
    const ctx = useReferentialContext();

    return <NeonCard sx={{height:'190px'}}>
        <NeonCardHeader title={props.title} sx={{height:'50px'}}/>
        <NeonCardContent sx={{height:'140px', flexDirection:'column'}}>
            {/*<Typography>{JSON.stringify(props.stats[0])}</Typography>*/}
            {/*<Typography>{JSON.stringify(props.stats[1])}</Typography>*/}
            <Stack direction={'row'} sx={{width:'100%', alignItems:'space-between', justifyContent:'space-between'}}>
                        <Typography sx={{width:'25px', textAlign:'center'}}>Shield</Typography>
                        <Typography sx={{width:'25px', textAlign:'center'}}>Rounds</Typography>
                        <Typography  sx={{width:'40px'}}>WR</Typography>
                    </Stack>
            <CenteredStack direction={'column'} sx={{width: '100%'}}>
                {
                    props.stats.map(s => <Stack direction={'row'} sx={{width:'100%', alignItems:'space-between', justifyContent:'space-between'}}>
                        {s.shield ? <ShieldIcon shield={s.shield} sx={{height: '25px', width: '25px'}}/> : <Block sx={{height: '25px', width: '25px'}}/> }
                        <Typography sx={{width:'25px', textAlign:'center'}}>{formatters.integer(s.round_id__cnt)}</Typography>
                        <Typography  sx={{width:'40px'}}>{formatters.percent(s.win__avg)}</Typography>
                    </Stack>)
                }
            </CenteredStack>
        </NeonCardContent>
    </NeonCard>
}